import { capitalize } from './capitalize';
import { jobTitles } from './create-avatar';
import { seededRandom } from './seeded-random';

export const getAnonymousGuestName = (seed: string) => {
  if (!seed) return 'Anonymous';
  const jobTitleInxes = Math.floor(seededRandom(seed + 'a') * jobTitles.length);
  return `Anonymous ${capitalize(jobTitles[jobTitleInxes])}`;
};
